import styled from "styled-components";

const StyledHero = styled.header`
    
    background: url(${props => props.img}) center/cover no-repeat;
    
`;

export default StyledHero;